import { render, staticRenderFns } from "./TransactionDeletionsGrid.vue?vue&type=template&id=6a1dc828&scoped=true&"
import script from "./TransactionDeletionsGrid.vue?vue&type=script&lang=ts&"
export * from "./TransactionDeletionsGrid.vue?vue&type=script&lang=ts&"
import style0 from "./TransactionDeletionsGrid.vue?vue&type=style&index=0&id=6a1dc828&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a1dc828",
  null
  
)

export default component.exports